import React from "react";

/**
 * ProfileIcon component renders a profile icon SVG.
 *
 * @return {JSX.Element} The profile icon SVG
 */
export const ProfileIcon = ({ cls }) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 24 25"
      fill="none"
      className="cls ml-[-3px]"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 12.5C13.4889 12.5 14.4556 12.2068 15.2779 11.6574C16.1001 11.1079 16.741 10.3271 17.1194 9.41342C17.4978 8.49979 17.5969 7.49446 17.4039 6.52455C17.211 5.55465 16.7348 4.66373 16.0355 3.96447C15.3363 3.26521 14.4454 2.789 13.4755 2.59608C12.5055 2.40315 11.5002 2.50217 10.5866 2.8806C9.67295 3.25904 8.89206 3.89991 8.34265 4.72215C7.79324 5.5444 7.5 6.5111 7.5 7.5C7.50132 8.82568 8.02853 10.0967 8.96593 11.0341C9.90332 11.9715 11.1743 12.4987 12.5 12.5ZM12.5 4.16667C13.1593 4.16667 13.8037 4.36217 14.3519 4.72844C14.9001 5.09471 15.3273 5.6153 15.5796 6.22439C15.8319 6.83348 15.8979 7.5037 15.7693 8.1503C15.6407 8.79691 15.3232 9.39085 14.857 9.85703C14.3908 10.3232 13.7969 10.6407 13.1503 10.7693C12.5037 10.8979 11.8335 10.8319 11.2244 10.5796C10.6153 10.3273 10.0947 9.90007 9.72844 9.3519C9.36216 8.80374 9.16667 8.15927 9.16667 7.5C9.16667 6.61595 9.51786 5.7681 10.143 5.14298C10.7681 4.51786 11.6159 4.16667 12.5 4.16667Z"
        fill="currentColor"
      />
      <path
        d="M12.5 14.5C10.5116 14.5021 8.60518 15.2614 7.19914 16.6112C5.79309 17.961 5.00221 19.7911 5 21.7C5 21.9122 5.0878 22.1157 5.24408 22.2657C5.40036 22.4157 5.61232 22.5 5.83333 22.5C6.05435 22.5 6.26631 22.4157 6.42259 22.2657C6.57887 22.1157 6.66667 21.9122 6.66667 21.7C6.66667 20.2148 7.28125 18.7904 8.37521 17.7402C9.46917 16.69 10.9529 16.1 12.5 16.1C14.0471 16.1 15.5308 16.69 16.6248 17.7402C17.7188 18.7904 18.3333 20.2148 18.3333 21.7C18.3333 21.9122 18.4211 22.1157 18.5774 22.2657C18.7337 22.4157 18.9457 22.5 19.1667 22.5C19.3877 22.5 19.5996 22.4157 19.7559 22.2657C19.9122 22.1157 20 21.9122 20 21.7C19.9978 19.7911 19.2069 17.961 17.8009 16.6112C16.3948 15.2614 14.4884 14.5021 12.5 14.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
